export default __webpack_public_path__ + "static/media/E3app.c5b829be.svg";